// Condition scale (grades, colors, multipliers, labels, normalization) lives
// in a single source of truth. Re-exported here so existing imports keep
// working unchanged.
export {
  CONDITIONS,
  CONDITION_MULTIPLIERS,
  CONDITION_COLORS,
  CONDITION_LABELS,
  DEFAULT_CONDITION,
  normalizeCondition,
  conditionLabel,
  conditionCode,
} from './conditionScale';

export const COLLECTION_TYPES = [
  { value: 'glory', label: 'Glory', icon: 'emoji_events' },
  { value: 'trade', label: 'Trade Binder', icon: 'swap_horiz' },
  { value: 'sale', label: 'For Sale', icon: 'storefront' },
];

// Re-export from the price adapter so all existing imports keep working.
// To switch pricing source, edit src/utils/priceAdapter.js only.
export {
  getRawPrice as getBasePrice,
  getAdjustedPrice,
  getConditionPrice,
  getFairTradePercent,
  getValueDifference,
  getTradeSideValue,
  getTradeCardSnapshotValue,
  hasRawPrice,
  hasTradeSidePrice,
  hasSnapshotPrice,
} from './priceAdapter';
